const page = "_35sp11wxmpj";
const meta = "_35smiecfm1";
const headingWrapper = "_35sh1ptj4vq";
const label = "_35sl6dj2wj";
const heading = "_35sh1nr3mzt";
const pieWrapper = "_35sp1dvfolm";
const contentWrapper = "_35scswfs2l";
const tasksWrapper = "_35st2e7ntx";

export { contentWrapper, heading, headingWrapper, label, meta, page, pieWrapper, tasksWrapper };
import "./page.overview.style.linaria.module.css";
//# sourceMappingURL=page.overview.style.js.map
